import React from "react";
import "./Terms.css";

const Terms = () => {
  return (
    <main className="terms-page">
      <div className="terms-container">
        <header className="terms-header">
          <h1>Terms &amp; Conditions</h1>
          <p className="terms-sub">
            Please read these terms carefully before using our website or
            placing an order. By using our site, you agree to be bound by these
            Terms &amp; Conditions.
          </p>
        </header>

        <article className="terms-card">
          <h2>1. Introduction</h2>
          <p>
            Welcome to <span className="brand">Shawl Haus</span>. By using
            our website and making a purchase, you agree to comply with these
            Terms &amp; Conditions. Please read them carefully before ordering.
          </p>
        </article>

        <article className="terms-card">
          <h2>2. Orders &amp; Payment</h2>
          <ul>
            <li>All orders are subject to product availability.</li>
            <li>Prices and availability may change without notice.</li>
            <li>
              Payment must be completed at checkout via the available payment
              methods.
            </li>
          </ul>
        </article>

        <article className="terms-card">
          <h2>3. Sales &amp; Returns</h2>
          <ul>
            <li>All sales are final. No returns or exchanges are accepted.</li>
            <li>
              Custom or personalized items are also final sale, unless there is
              a design or manufacturing error by <span className="brand">Shawl Haus</span>.
            </li>
            <li>Shipping/delivery fees are non-refundable.</li>
          </ul>
        </article>

        <article className="terms-card">
          <h2>4. Shipping &amp; Delivery</h2>
          <ul>
            <li>We ship domestically and internationally.</li>
            <li>Delivery times are estimated and may vary.</li>
            <li>
              Customers are responsible for any customs duties, taxes, or import
              fees for international orders.
            </li>
          </ul>
        </article>

        <article className="terms-card">
          <h2>5. Intellectual Property</h2>
          <p>
            All content, images, logos, and designs on this website are the
            property of <span className="brand">Shawl Haus</span> and are
            protected by copyright and other intellectual property laws.
            Unauthorized use of our content is strictly prohibited.
          </p>
        </article>

        <article className="terms-card">
          <h2>6. Limitation of Liability</h2>
          <p>
            <span className="brand">Shawl Haus</span> is not liable for
            any indirect, incidental, or consequential damages arising from the
            use of our website or products. We are not responsible for shipping
            delays caused by carriers or customs authorities.
          </p>
        </article>

        <article className="terms-card">
          <h2>7. Governing Law</h2>
          <p>
            These Terms &amp; Conditions are governed by the laws of{" "}
            <strong>[Your Country/State]</strong>.
          </p>
        </article>

        <footer className="terms-footer">
          <p>
            If you have questions about these Terms &amp; Conditions, please
            contact us at <a href="mailto:Contact@shawlhaus.com">Contact@shawlhaus.com</a>.
          </p>
          <p className="small">Last updated: <time>2025-09-25</time></p>
        </footer>
      </div>
    </main>
  );
};

export default Terms;
